export default "__VITE_ASSET__D4Eo1p3d__"